"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var __1 = require("../");
var _1 = require("./");
var inversify_1 = require("inversify");
var CalendarLookups = /** @class */ (function () {
    function CalendarLookups(rsvpInvitationType, rsvpAttendeeStatus, eventStatus, eventType) {
        this.rsvpInvitationType = rsvpInvitationType;
        this.rsvpAttendeeStatus = rsvpAttendeeStatus;
        this.eventStatus = eventStatus;
        this.eventType = eventType;
    }
    var _a, _b, _c, _d;
    CalendarLookups = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpInvitationTypeClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeStatusClient)),
        tslib_1.__param(2, inversify_1.inject(__1.TYPES.CalendarEventStatusClient)),
        tslib_1.__param(3, inversify_1.inject(__1.TYPES.CalendarEventTypeClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CalendarEventRsvpInvitationTypeClient !== "undefined" && _1.CalendarEventRsvpInvitationTypeClient) === "function" ? _a : Object, typeof (_b = typeof _1.CalendarEventRsvpAttendeeStatusClient !== "undefined" && _1.CalendarEventRsvpAttendeeStatusClient) === "function" ? _b : Object, typeof (_c = typeof _1.CalendarEventStatusClient !== "undefined" && _1.CalendarEventStatusClient) === "function" ? _c : Object, typeof (_d = typeof _1.CalendarEventTypeClient !== "undefined" && _1.CalendarEventTypeClient) === "function" ? _d : Object])
    ], CalendarLookups);
    return CalendarLookups;
}());
exports.CalendarLookups = CalendarLookups;
